/**
 * Garage Loading Screen Component
 * Unified loading state for AI Garage with garage design aesthetic
 */

import React from 'react';
import './GarageLoadingScreen.css';

const GarageLoadingScreen = ({ message = 'Loading...', fullscreen = false, compact = false }) => {
  return (
    <div
      className={`garage-loading-screen ${fullscreen ? 'fullscreen' : ''} ${compact ? 'compact' : ''}`}
      role="status"
      aria-live="polite"
    >
      <div className="garage-loading-content">
        {/* Animated Logo/Icon */}
        <div className="garage-loading-icon" aria-hidden="true">
          <div className="garage-loading-ring"></div>
          <div className="garage-loading-ring-delayed"></div>
          <div className="garage-loading-center">
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M13 2L3 14h8l-1 8 10-12h-8l1-8z"
                fill="currentColor"
              />
            </svg>
          </div>
        </div>

        {/* Loading Message */}
        <p className="garage-loading-message">{message}</p>

        {/* Animated Dots */}
        <div className="garage-loading-dots" aria-hidden="true">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </div>
  );
};

// Keep affected content mounted; callers can place the status in a filter row or over the region.
export const GarageLoadingRegion = ({ loading, message = 'Updating…', compact = true, showIndicator = true, children }) => (
  <div className={`garage-loading-region ${loading ? 'is-loading' : ''}`}>
    <div className="garage-loading-region-content" aria-busy={loading} inert={loading ? '' : undefined}>
      {children}
    </div>
    {loading && showIndicator && (
      <div className="garage-loading-region-overlay">
        <GarageLoadingScreen message={message} compact={compact} />
      </div>
    )}
  </div>
);

export default GarageLoadingScreen;
